import React from 'react';
import { useAppSelector } from '../../store';
import WindowPanel from './WindowPanel';
import { WindowContentMap } from './WindowContent';
import logger from '../../services/logger';

export interface WindowContainerProps {
  className?: string;
}

const WindowContainer: React.FC<WindowContainerProps> = ({ className = '' }) => {
  const windows = useAppSelector(state => state.windows.windows);
  const windowIds = Object.keys(windows).filter(id => windows[id].isOpen);

  if (windowIds.length === 0) {
    logger.debug('No windows are currently open', { module: 'windows' });
    return null;
  }

  return (
    <div className={`absolute inset-0 pointer-events-none ${className}`}>
      {windowIds.map(id => {
        const windowData = windows[id];
        const ContentComponent = WindowContentMap[windowData.type];
        
        return (
          <WindowPanel
            key={id}
            id={id}
            title={windowData.title}
            className="pointer-events-auto"
          >
            {ContentComponent ? (
              <ContentComponent windowId={id} />
            ) : (
              <div className="p-4">
                <p>{windowData.content || 'No content available'}</p>
              </div>
            )}
          </WindowPanel>
        );
      })}
    </div>
  );
};

export default WindowContainer; 